import Grid from '../../components/Grid';
import Cirugias from '../../components/cirugias/admin_cirugias.vue';
import routeService from '../../services/route_service.js';
import LoginService from '../../services/login_service.js';
import Facturar from '../../components/facturar/admin_facturar.vue';

//const alertService = new AlertService();
const loginService = new LoginService();
/*const generalService = new GeneralService();
const cirugiaService = new CirugiaService();*/

let _this;
export default {
	name: 'facturacion',
	components: { Grid, Cirugias, Facturar },
	data: function() {
		return {
			titulo: 'FACTURACION',
			actions: [{
				icon: 'cash',
				name: 'Facturar',
				actionBtn: this.facturar,
				buttonClass: 'btn btn-xs btn-primary',
				hide: function() { return true }
			}],
			modalCirugia: {},
			columns: [
				{key: 'idCirugia', value: 'Id'},
				{key: 'idInternacionCirugia', value: 'Internacion'},
				{key: 'fechaCirugia', value: 'Fecha'},
				{key: 'nomyApPaciente', value: 'Paciente'},
				{key: 'dniPaciente', value: 'DNI'},
				{key: 'obraSocialPaciente', value: 'Obra Social'},
				{key: 'nombreStaffInternacion', value: 'Staff'},
				{key: 'especialidadInternacion', value: 'Especialidad'},
				{key: 'sedeInternacion', value: 'Sede'},
				{key: 'fechaCargaFacturacion', value: 'Fecha facturacion'},
				{key: 'valorFacturacion', value: 'Valor'},
				{key: 'cobradoFacturacion', value: 'Cobrado'},
				{key: 'diferencialFacturacion', value: 'Diferencial'},
			] 
		};
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		if(!loginService.hasPermission("listado", "cirugias")) {
			routeService.goToHome();
			return;
		}
		if(routeService.getParams().idPacienteInternacion != undefined) {
			if(!isNaN(routeService.getParams().idPacienteInternacion)) {
				this.search.idPacienteInternacion = routeService.getParams().idPacienteInternacion;
			}
		}
		if(routeService.getParams().idInternacionCirugia != undefined) {
			if(!isNaN(routeService.getParams().idInternacionCirugia)) {
				this.search.idInternacionCirugia = routeService.getParams().idInternacionCirugia;
			}
		}
	}, 
	methods: { 
		facturar(item) {
			//_this.modalCirugia = item;
			//this.$root.$emit('bv::show::modal', 'facturar');
			//this.$bvModal.show('facturar');
			routeService.goTo("facturar/" + item.idCirugia);			
		},
		closeModal() {
			_this.$root.$emit('bv::hide::modal', 'facturar');
			_this.$refs.cdata.getData()			
		}
	}
}

